import { clsx } from "clsx";
import { twMerge } from "tailwind-merge"

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

// Guarda la sesión propia antes de entrar a otra empresa; si ya estamos en una sesión asistida se conserva la original
export function guardarSesionPrevia(volverA) {
  const actual = localStorage.getItem("aipos_token") || "";
  let asistida = false;
  try { asistida = !!JSON.parse(atob(actual.split(".")[1].replace(/-/g, "+").replace(/_/g, "/"))).impersonating; } catch (e) { asistida = false; }
  if (!asistida || !localStorage.getItem("aipos_token_prev")) localStorage.setItem("aipos_token_prev", actual);
  if (volverA) localStorage.setItem("aipos_assist_return", volverA);
}
